// 🔧 vote_step.js
// ✅ Purpose: Vote Builder pipeline step
// ✅ Features:
// - Executes the Vote Builder
// - Creates standardized pipeline results
// - Updates DemoContext
// - Fully block-commented for clarity and future devs

import { createPipelineStepSuccess } from "../pipeline_step";
import { buildVoteShell } from "../../builders/vote_builder";

export const createVoteStep = () => ({
  name: "vote_builder",

  label: "Vote Builder",

  run: async (context) => {
    const result = await buildVoteShell(context);

    return createPipelineStepSuccess({
      step: "vote_builder",
      label: "Vote Builder",

      created:
        result?.createdCount ||
        result?.plannedCount ||
        0,

      message: result?.message,

      metadata: result,

      startedAt: context.startedAt,
    });
  },

  afterSuccess: ({ result, sharedContext }) => {
    sharedContext.voteResult =
      result?.metadata || null;

    sharedContext.votes =
      result?.metadata?.createdVotes || [];
  },
});